import { api } from './api';

/* Full-text search across the caller's own messages. CLEAN-ARCH (Vague 4) : via */
/* le port tRPC (api.messages.search) → RPC search_user_messages (owner-scopé */
/* server-side), au lieu de supabase-js direct. */
export interface MessageSearchRow {
  thread_id: string | null;
  transcript: string;
}

export async function searchMyMessages(query: string): Promise<MessageSearchRow[]> {
  return (await api.messages.search.query({ query })) as MessageSearchRow[];
}
